import React from 'react';

export default function HuongDanMuaHang() {
  return (
    <div className="bg-white text-gray-800 py-12 px-4 md:px-8 lg:px-16 max-w-6xl mx-auto mt-16">
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-bold text-pink-600 uppercase">
          Hướng Dẫn Mua Hàng
        </h1>
        <p className="mt-4 text-gray-600 text-base md:text-lg">
          Cùng PT2000 trải nghiệm mua sắm thời trang nhanh chóng, tiện lợi và an toàn!
        </p>
      </div>

      <div className="space-y-10">
        {/* Bước 1 */}
        <div className="flex flex-col md:flex-row items-start gap-6">
          <div className="text-pink-500 text-4xl font-bold">1</div>
          <div>
            <h2 className="text-xl font-semibold mb-2">Chọn sản phẩm yêu thích</h2>
            <p className="text-gray-700 leading-relaxed">
              Truy cập <a href="/" className="text-pink-600 underline">trang sản phẩm</a> để xem các bộ sưu tập thời trang mới nhất. Bạn có thể lọc theo loại sản phẩm, màu sắc hoặc kích thước.
            </p>
          </div>
        </div>

        {/* Bước 2 */}
        <div className="flex flex-col md:flex-row items-start gap-6">
          <div className="text-pink-500 text-4xl font-bold">2</div>
          <div>
            <h2 className="text-xl font-semibold mb-2">Kiểm tra thông tin sản phẩm</h2>
            <p className="text-gray-700 leading-relaxed">
              Nhấn vào hình ảnh để xem chi tiết sản phẩm, chọn size phù hợp với bạn theo bảng hướng dẫn và đọc kỹ mô tả sản phẩm.
            </p>
          </div>
        </div>

        {/* Bước 3 */}
        <div className="flex flex-col md:flex-row items-start gap-6">
          <div className="text-pink-500 text-4xl font-bold">3</div>
          <div>
            <h2 className="text-xl font-semibold mb-2">Thêm vào giỏ hàng</h2>
            <p className="text-gray-700 leading-relaxed">
              Nhấn nút <strong>“Thêm vào giỏ hàng”</strong> để lưu sản phẩm. Sau đó bạn có thể tiếp tục mua sắm hoặc chuyển sang bước thanh toán.
            </p>
          </div>
        </div>

        {/* Bước 4 */}
        <div className="flex flex-col md:flex-row items-start gap-6">
          <div className="text-pink-500 text-4xl font-bold">4</div>
          <div>
            <h2 className="text-xl font-semibold mb-2">Thanh toán đơn hàng</h2>
            <p className="text-gray-700 leading-relaxed">
              Bạn được thanh toán khi sản phẩm đến tận tay. Điền đầy đủ thông tin người nhận và xác nhận đơn hàng.
            </p>
          </div>
        </div>

        {/* Bước 5 */}
        <div className="flex flex-col md:flex-row items-start gap-6">
          <div className="text-pink-500 text-4xl font-bold">5</div>
          <div>
            <h2 className="text-xl font-semibold mb-2">Theo dõi & nhận hàng</h2>
            <p className="text-gray-700 leading-relaxed">
              Đơn hàng sẽ được giao đến tay bạn từ 2–5 ngày làm việc (tuỳ khu vực).
            </p>
          </div>
        </div>
      </div>

      {/* Liên hệ hỗ trợ */}
      <div className="mt-16 text-center border-t pt-8">
        <p className="text-gray-700">
          Nếu bạn gặp khó khăn trong quá trình đặt hàng, vui lòng gọi&nbsp;
          <a href="tel:0784992000" className="text-pink-600 underline font-medium">
            0784 992 000
          </a> để được hỗ trợ nhanh nhất.
        </p>
      </div>
    </div>
  );
}


